"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncVoiceLibraryDtoProvidersItem = void 0;
exports.SyncVoiceLibraryDtoProvidersItem = {
    ElevenLabs: "11labs",
    Azure: "azure",
    Cartesia: "cartesia",
    CustomVoice: "custom-voice",
    Deepgram: "deepgram",
    Lmnt: "lmnt",
    Neets: "neets",
    Openai: "openai",
    Playht: "playht",
    RimeAi: "rime-ai",
    SmallestAi: "smallest-ai",
    Tavus: "tavus",
};
